import { NgModule } from '@angular/core';
import { ModusIcon } from './modus-icon.component';

@NgModule({
  declarations: [ModusIcon],
  exports: [ModusIcon],
})
export class ModusIconModule {}
